import { X } from 'lucide-react'

export interface FilterChip {
  key: string
  label: string
  value: string
  onRemove: () => void
}

interface GerencialFilterChipsProps {
  chips: FilterChip[]
  onClearAll: () => void
}

export function GerencialFilterChips({ chips, onClearAll }: GerencialFilterChipsProps) {
  if (chips.length === 0) return null
  return (
    <div className="flex items-center gap-2 flex-wrap">
      <span className="text-xs text-brand-gray uppercase tracking-wide font-semibold">
        Ativos:
      </span>
      {chips.map(chip => (
        <button
          key={chip.key}
          type="button"
          onClick={chip.onRemove}
          className="inline-flex items-center gap-1 px-2 py-1 bg-brand-primary/10 border border-brand-primary/30 rounded-full text-xs text-brand-primary hover:bg-brand-primary/20 transition-colors"
          aria-label={`Remover filtro ${chip.label}`}
        >
          <X size={12} />
          <span className="font-medium">{chip.label}:</span>
          <span className="truncate max-w-[160px]">{chip.value}</span>
        </button>
      ))}
      <button
        type="button"
        onClick={onClearAll}
        className="text-xs text-brand-gray hover:text-white underline transition-colors ml-1"
      >
        Limpar todos
      </button>
    </div>
  )
}
